import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Tag} from "../../../../shared/interface/tag";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {src} from "../../../../../environments/environment";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {
  DictService, POST_TAG_TYPE_DEPARTMENT_TYPE,
  POST_TAG_TYPE_INSURANCE_COMPANY,
  POST_TAG_TYPE_POST_TYPE
} from "../../../../shared/services/dict.service";
import {takeUntil} from "rxjs/operators";
import {FormBuilder, FormControl} from "@angular/forms";
import {AvatarCropDialogComponent} from "../../../user/avatar-crop-dialog/avatar-crop-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {TagService} from "../../../../shared/services/tag.service";

@Component({
  selector: 'app-tags-details-view',
  templateUrl: './tags-details-view.component.html',
  styleUrls: ['./tags-details-view.component.scss']
})
export class TagsDetailsViewComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() tag: Observable<Tag>;
  @Output() modifyClicked = new EventEmitter<any>();
  @ViewChild('imageSelect')    imageSelect: ElementRef;

  imageSelectControl: FormControl;
  tagObject?: Tag;
  userPermissions: ReplaySubject<UserPermissions>;
  imgCnt = 0;
  readonly src = src;
  readonly POST_TAG_TYPE_POST_TYPE = POST_TAG_TYPE_POST_TYPE;
  readonly POST_TAG_TYPE_INSURANCE_COMPANY = POST_TAG_TYPE_INSURANCE_COMPANY;
  readonly POST_TAG_TYPE_DEPARTMENT_TYPE = POST_TAG_TYPE_DEPARTMENT_TYPE;

  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private dictService: DictService,
    private fb: FormBuilder,
    private tagService: TagService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.imageSelectControl = fb.control('');

  }

  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    this.tag
      .pipe(takeUntil(this.destroyed$))
      .subscribe((tag: Tag) => {
        this.tagObject = tag;
      });

    this.imageSelectControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (!this.imageSelect.nativeElement.files[0]) {
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(this.imageSelect.nativeElement.files[0]);
        reader.onload = () => {
          const fileBase64 = reader.result.toString();
          const dialogRef = this.dialog.open(AvatarCropDialogComponent, {
            width: '55%',
            data: {fileBase64, ratio: 1, roundCropper: true, maintainRatio: true, compressedFile: true},
            height: '610px',
            maxHeight: '90%',
            panelClass: 'full-height-dialog',
          });

          dialogRef.afterClosed().subscribe(result => {
            if (!result) {
              this.imageSelectControl.reset();
              return;
            }

            this.tagService.updateImage(this.tagObject.id, result)
              .subscribe(() => {
                this.snack.open('Pomyślnie zmieniono zdjęcie', '', {duration: 2000});
                this.imgCnt++;
                this.imageSelectControl.reset();
                this.load();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Przy aktualizacji zdjęcia wystąpił błąd', error.status.toString(), {duration: 2000});
                this.imageSelectControl.reset();
              });
          });
        };
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  setImage(): void {
    const e: HTMLElement = this.imageSelect.nativeElement;
    e.click();
  }

  load(): void {
    this.tagService.get(this.tagObject.id).subscribe((tag: Tag) => {
      this.tagObject = tag;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
